import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LogIn, Loader2, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_6e85a7b3-7844-4782-8600-31defd3a9a43/artifacts/5fhyey8q_MV%20trasporti%20logo.png";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast.error("Inserisci email e password"); return; }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("mv_admin_token", res.data.token);
      localStorage.setItem("mv_admin_name", res.data.name);
      toast.success(`Benvenuto, ${res.data.name}!`);
      const next = params.get("next");
      navigate(next && next.startsWith("/admin") ? next : "/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <img src={LOGO_URL} alt="MV Trasporti" className="h-14 w-auto mx-auto invert mb-4" />
          <p className="text-sm font-bold tracking-widest uppercase text-[#FF5200] font-heading">
            Pannello Amministrazione
          </p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white p-8 space-y-6" data-testid="admin-login-form">
          <div>
            <label className="block text-sm font-bold tracking-widest uppercase text-zinc-500 mb-2 font-heading">Email</label>
            <input
              type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full h-12 px-4 border-2 border-zinc-200 rounded-sm focus:border-[#FF5200] outline-none font-body"
              placeholder="admin@mvtrasporti.com" data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="block text-sm font-bold tracking-widest uppercase text-zinc-500 mb-2 font-heading">Password</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full h-12 pl-4 pr-12 border-2 border-zinc-200 rounded-sm focus:border-[#FF5200] outline-none font-body"
                placeholder="La tua password" data-testid="admin-login-password"
                autoComplete="off"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-400 hover:text-zinc-700"
                aria-label={showPassword ? "Nascondi password" : "Mostra password"}
                data-testid="toggle-password-visibility"
                tabIndex={-1}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          <button
            type="submit" disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 bg-[#FF5200] text-white h-12 font-bold uppercase tracking-wide rounded-sm hover:bg-[#e64a00] transition-colors font-heading text-sm disabled:opacity-50"
            data-testid="admin-login-submit"
          >
            {loading ? <Loader2 size={18} className="animate-spin" /> : <LogIn size={18} />}
            Accedi
          </button>
        </form>

        <p className="text-center text-zinc-500 text-xs mt-6 font-body">
          Accesso riservato al personale autorizzato
        </p>
      </div>
    </div>
  );
}
